import React, { Component } from 'react'
import AddTitleBar from '../../../components/titleBar/add_titleBar';
import InsertVendors from '../../../components/vendorComponent/insertVendor';
import { translate } from "react-i18next";
import ReadVAxios from "../../../components/axiosComponent/readV";
import { isEmpty } from 'lodash';
import RateChart from './rateChart';
import { aesDecrypt } from '../../../utils/commonFunctionalities';

class Vendor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: localStorage.getItem('customerNumber') != 1158 ? "add_vendor_title" : "add_title",
            editData: {},
            rowData: [],
            loadingData: true,
        };
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.title) {
            this.setState({
                title: localStorage.getItem('customerNumber') != 1158 ? "edit_vendor_title" : this.props.location.state.title,
                // editData: { ...this.props.location.state },
            });
        }
        if (this.props.location.state) {
            ReadVAxios({ url: `vendorDetails/${this.props.location.state.transporterMasterId}` })
                .then(async (dataArray) => {
                   if(dataArray?.data?.resultSet){
                    let resultSet = dataArray.data.resultSet
                    if(resultSet.companyPan) resultSet.companyPan = await aesDecrypt(resultSet.companyPan)
                    if(resultSet?.branches?.length){
                        for(let branch of resultSet?.branches){
                            if(branch.vendorBranchGST) branch.vendorBranchGST = await aesDecrypt(branch.vendorBranchGST)
                            if(branch.vendorBranchAccountNumber) branch.vendorBranchAccountNumber = await aesDecrypt(branch.vendorBranchAccountNumber)
                            if(branch.vendorBranchBankIFSC) branch.vendorBranchBankIFSC = await aesDecrypt(branch.vendorBranchBankIFSC)
                        }
                    }
                    this.setState({ loadingData: false, editData: dataArray.data.resultSet });
                   }else{
                    this.setState({ loadingData: false, editData: {} })
                   }

                }, () => console.log("check eiditdata : ", this.state.editData))
                .catch((err) => {
                    console.log(err);
                    // this.setState({ loadingData: false, rowData: [] });
                });
        }
    }

    onFormSubmit = () => {
        this.props.history.push("/vendor");
        // this.props.history.go();
    };

    render() {
        const { t } = this.props;
        const { editData } = this.state;
        return (
            <React.Fragment>
                <AddTitleBar Title={t(this.state.title)} LinkName="/vendor" />
                <div className="m-2">
                    <InsertVendors
                        editData={editData}
                        onFormSubmit={this.onFormSubmit}
                        // usersList={this.state.rowData}
                        action={this.state.title}
                    />
                </div>
                <div className="container-fluid">
                    <br />
                    <RateChart {...this.props} vendorCode={this?.props?.location?.state?.transporterMasterId || 0} />
                </div>
            </React.Fragment>
        )
    }
}

export default translate("create_vendor")(Vendor);